import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { Store } from '@ngrx/store'
import { map, take, tap } from 'rxjs/operators'

import { AppState } from '../../../store'
import * as App from '../../../store/actions/app.actions'
import * as fromStore from '../store'

import { shouldGrant } from '../auth.service'
import { LoggedVendorUserV1 } from '../../../api/api/models/logged-vendor-user-v1'

@Injectable()
export class RolesGuard implements CanActivate {

  constructor(private store: Store<AppState>) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const userRoles = route.data['userRoles']
    const teamRoles = route.data['teamRoles']
    const fallback = route.data['fallbackRoute'] || 'conversations'

    return this.store.select(fromStore.getAuthUser).pipe(
      map((user: LoggedVendorUserV1) => user && shouldGrant(user, userRoles, teamRoles)),
      tap(grant => {
        if (!grant && fallback) {
          this.store.dispatch(new App.Go({path: [fallback]}))
        }
      }),
      take(1))
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/auth/guargs/roles.guard.ts